"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeout = exports.getParentHeight = exports.dispatchWcEvent = exports.isPermissionPresent = exports.formatNumbers = exports.transformToBoolean = exports.customElement = exports.Symbols = exports.currencySymbol = exports.formatPrice = exports.getEndpoint = exports.getHeaders = exports.getData = void 0;
var fetchWrapper_1 = require("./fetchWrapper");
Object.defineProperty(exports, "getData", { enumerable: true, get: function () { return fetchWrapper_1.getData; } });
Object.defineProperty(exports, "getHeaders", { enumerable: true, get: function () { return fetchWrapper_1.getHeaders; } });
Object.defineProperty(exports, "getEndpoint", { enumerable: true, get: function () { return fetchWrapper_1.getEndpoint; } });
var formatPrice_1 = require("./formatPrice");
Object.defineProperty(exports, "formatPrice", { enumerable: true, get: function () { return formatPrice_1.formatPrice; } });
var currencySymbol_1 = require("./currencySymbol");
Object.defineProperty(exports, "currencySymbol", { enumerable: true, get: function () { return currencySymbol_1.currencySymbol; } });
var specialSymbols_1 = require("./specialSymbols");
Object.defineProperty(exports, "Symbols", { enumerable: true, get: function () { return specialSymbols_1.Symbols; } });
var decorators_1 = require("./decorators");
Object.defineProperty(exports, "customElement", { enumerable: true, get: function () { return decorators_1.customElement; } });
Object.defineProperty(exports, "transformToBoolean", { enumerable: true, get: function () { return decorators_1.transformToBoolean; } });
var formatNumbers_1 = require("./formatNumbers");
Object.defineProperty(exports, "formatNumbers", { enumerable: true, get: function () { return formatNumbers_1.formatNumbers; } });
var permissions_1 = require("./permissions");
Object.defineProperty(exports, "isPermissionPresent", { enumerable: true, get: function () { return permissions_1.isPermissionPresent; } });
const dispatchWcEvent = (component, name, detail) => {
    component.dispatchEvent(new CustomEvent(name, {
        detail,
        composed: true,
    }));
};
exports.dispatchWcEvent = dispatchWcEvent;
const getParentHeight = (element) => {
    let selector = document.querySelector(element.tagName);
    return selector.parentNode.clientHeight;
};
exports.getParentHeight = getParentHeight;
const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.timeout = timeout;
